


























































import { Component } from 'vue-property-decorator';
import { mixins } from 'vue-class-component';

import { required, email } from 'vuelidate/lib/validators';
import { formMixin } from '~/utils/form';
import { objectIsEmpty } from '~/utils/common.js';

import EmailInput from '~/components/inputs/EmailInput.vue';
import PasswordInput from '~/components/inputs/PasswordInput.vue';
import ErrorCard from '~/components/cards/ErrorCard.vue';
import SocialSign from '~/components/lists/SocialSign.vue';

@Component({
  layout: 'signin',
  components: {
    EmailInput,
    PasswordInput,
    ErrorCard,
    SocialSign,
  },
  middleware: 'noauth',
  validations: {
    email: { required, email },
    password: { required },
  },
  head () {
    const self: any = this;
    const locale: string = self.$store.state.lang.locale;

    return {
      title: `${self.$t('SignInForm.submitButtonLabel')} - On Piste`,
      meta: [
        {
          hid: 'og:title',
          property: 'og:title',
          content: `${self.$t('SignInForm.submitButtonLabel')} - On Piste`,
        },
        {
          hid: 'og:image',
          property: 'og:image',
          content: 'https://www.onpiste.com/img/sign/img__rossignol__trail3.png',
        },
        {
          hid: 'og:url',
          property: 'og:url',
          content: `https://www.onpiste.com/${locale === 'fr' ? '' : `${locale}/`}signin`,
        },
      ],
    };
  },
})
export default class SignIn extends mixins(formMixin) {
  error: string = "";
  email: string = "";
  password: string = "";

  /*
    Returns a boolean to disable submit button if two validations
    datas are empty
  */
  get submitDisabled (): boolean {
    return !this.email || !this.password;
  }

  mounted () {
    this.$store.commit('user/SET_SIGN_IMAGE', '/img/sign/img__rossignol__trail3.png');
  }

  /*
    This method is triggered by socials components, in the case user sign in with
    a social account but has failed. The user will use the classic signup process
    instead.
  */
  onNeedSignup (data: Types.SocialUserInfo) {
    this.$store.commit("user/SET_LOGIN_FORM", data);
    // Interrupt the current form because a social login as been attempted
    // but failed. This means the user must now finish the signup process instead.
    const route: any = this.localePath("/signup/email");
    this.$router.push(route);
  }

  /*
    This method will redirect user when has a success signIn process with a
    social account.
  */
  onSignedIn () {
    if (this.$route.query?.next) {
      const route: any = this.localePath({ path: `${this.$route.query.next}${this.$route.hash}` });
      this.$router.push(route);
    } else {
      const route: any = this.localePath("/profile/my-runs");
      this.$router.push(route);
    }
  }

  /* If any error occures on socials signin, we will display it in ErrorCard */
  onError (error: string) {
    this.error = error;
  }

  async created () {
    if (this.$route.query.signout === '1') {
      // This is handled when this component is ready, to be sure that the previous
      // one is destroyed. Otherwise, unwanted reactivity would be triggered by
      // unsetting user.me in the signout process while still being in a component
      // requiring auth.
      console.info('[signing out]');
      await this.$store.dispatch('user/signout');
      const { signout: _, ...query } = this.$route.query;

      // Workaround to fix not reactive topMenu layout update
      this.$root.$emit('force-menu-refresh');

      this.$router.replace({ query });
    }
  }

  /*
    The submit method will create a LoginForm with input values, then attempt
    a login. Errors are handled (validations and API responses)
  */
  async submit () {
    this.error = "";
    await this.formMixin_handleSubmit(async () => {
      const partialInfo: Partial<Types.LoginForm> = {
        email: this.email,
      };
      // Stored the entered info in case the user wants to continue in another form
      this.$store.commit("user/SET_LOGIN_FORM", partialInfo);

      await this.$store.dispatch("user/signinWithEmail", {
        email: this.email,
        password: this.password,
      });

      await this.$store.dispatch('user/sendPreferredUnit');

      this.onSignedIn();
    });
    // not using "!" as formMixin_error can also be null
    if (objectIsEmpty(this.formMixin_error) === false) {
      const mixinError: any = this.formMixin_error;

      this.formMixin_error = {
        statusCode: mixinError.response.status,
        response: { data: { detail: this.$t(mixinError.response.data.detail) } },
      };
    }
  }
}
